import { appStore } from '@tom-ui/utils'
import { useAllocationRulesMessageHandler } from '@yard/pages/YardSetup/hooks/useAllocationRulesMessageHandler'
import { GlobalAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/global-allocation-rules.view-store'
import { YardViewStore } from '@yard/pages/YardSetup/stores/yard.view-store'
import { FC } from 'react'
import { AllocationRulesActions } from '../../../atoms/AllocationRules/AllocationRulesActions'

type Props = {
  yardViewStore: YardViewStore
  globalAllocationRulesViewStore: GlobalAllocationRulesViewStore
}

export const GlobalAllocationRulesActions: FC<Props> = props => {
  const { yardViewStore, globalAllocationRulesViewStore } = props

  const { getExceptionMessage, getGlobalRulesSuccessMessage } = useAllocationRulesMessageHandler()

  const submitRules = async () => {
    try {
      await globalAllocationRulesViewStore.submitRules()
      globalAllocationRulesViewStore.setAllocationRulesDrawerOpen(false)
      yardViewStore.setCreateRuleFromFilter(false)
      appStore.setShowAlert('success', getGlobalRulesSuccessMessage())
    } catch (e) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  return (
    <AllocationRulesActions
      onSubmit={submitRules}
      onCancel={() => {
        globalAllocationRulesViewStore.resetChanges()
        yardViewStore.setShowAllocationRulesPreview(false)
        yardViewStore.setCreateRuleFromFilter(false)
      }}
      isFilterDrawerOpen={yardViewStore.isFilterDrawerOpen}
    />
  )
}
